import { createContext } from 'react'
import type { AuthContextValue } from './types'

// Kept in its own module (no component export) so React Fast Refresh can hot-
// reload AuthProvider without invalidating the context identity — mirrors
// AdminContext.ts / impersonationContext.ts.
export const AuthContext = createContext<AuthContextValue | null>(null)
